'use client'

import { darkTheme, lightTheme } from '@precis-digital/kurama/theme'
import { type ReactElement } from 'react'
import { LOCAL_STORAGE_KEYS } from 'shared/lstore'

const lightPageBackground = lightTheme.tokens.background.main.default
const darkPageBackground = darkTheme.tokens.background.main.default

export const ThemePreferenceScript = (): ReactElement => (
  <>
    <style>{`
      html[data-theme='light'] body { background-color: ${lightPageBackground}; }
      html[data-theme='dark'] body { background-color: ${darkPageBackground}; }
    `}</style>
    <script id="alvie-theme-preference">{`
      (function() {
        try {
          var key=${JSON.stringify(LOCAL_STORAGE_KEYS.COLOUR_THEME_PREFERENCE)};
          var pref=localStorage.getItem(key);
          var mode='light';
          if(pref==='system'){
            mode=window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
          }else if(pref==='dark'||pref==='light'){
            mode=pref;
          }
          document.documentElement.dataset.theme=mode;
          document.documentElement.style.colorScheme=mode;
        }catch(e){
        }
      })();
    `}</script>
  </>
)
